import { gql } from "@apollo/client";
import TimeAndStatusFragment from "../fragments/TimeAndStatus";
import RaceDetailsFragment from "../fragments/RaceDetails";
import WagerTypesFragment from "../fragments/WagerTypes";
import VideoFragment from "../fragments/Video";
import BettingInterestsSubscriptionFragment from "../fragments/BettingInterestsSubscription";

export default gql`
  subscription racesUpdate(
    $trackAbbr: String!
    $wagerProfile: String!
    $raceNumber: String!
    $product: String
    $brand: String
    $device: String
  ) {
    raceUpdate(profile: $wagerProfile, track: $trackAbbr, number: $raceNumber) {
      id
      tvgRaceId
      ...BettingInterests
      highlighted(product: $product, device: $device, brand: $brand) {
        description
        style
      }
      type {
        code
      }
      purse
      ...TimeAndStatus
      ...RaceDetails
      ...Video
      promos(product: $product, brand: $brand) {
        rootParentPromoID
        isAboveTheLine
        promoPath
        isPromoTagShown
      }
      ...WagerTypes
    }
  }
  ${TimeAndStatusFragment}
  ${RaceDetailsFragment}
  ${WagerTypesFragment}
  ${VideoFragment}
  ${BettingInterestsSubscriptionFragment}
`;
